import { getMediaPath, mediaUrls } from 'globalconfig/constants/mediaUrls';
import React, { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { columns, languages } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const UploadCustomPolicy = lazy(() => import(`@/modules/CustomPolicyUpload`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

export default function PolicyList(props) {
  const { i18n } = useTranslation();
  const [pagination, setPagination] = useState(false);

  const generateRows = (data) => {
    const updatedList = data?.map((item) => {
      var result = { ...item };
      result.policy = (
        <Icon
          variant="square"
          src={getMediaPath(mediaUrls.eldIcon)}
          onClick={() =>
            props.downloadCustomPolicy({
              apiId: 'downloadCustomPolicyApi',
              data: item?.policyDocId,
            })
          }
        />
      );
      result.name = (
        <>
          <p>{item.name}</p>
        </>
      );
      result.language = (
        <>
          <p>
            {
              languages.find((el) => {
                return el.value === item.language;
              })?.label
            }
          </p>
        </>
      );
      result.languageValue = item.language;
      result.nameValue = item.name;
      return result;
    });
    return updatedList || [];
  };

  return (
    <Table
      type="client"
      defaultSortBy={{
        sortBy: 'date',
        order: 'desc',
      }}
      title=""
      columns={columns}
      itemsPerPage={10}
      data={generateRows(props.customPolicy?.customPolicyList)}
      emptyMessage={i18n.t('common.tableEmptyMessage')}
      isPaginationNeeded="true"
      pageinationReset={pagination}
      pagenationClicked={(e) => {
        setPagination(!e);
      }}
      actions={[
        {
          icon: (row, index) => {
            return (
              <React.Fragment key={index}>
                <Icon
                  src={mediaUrls?.edit}
                  onClick={() => {
                    props.setwithCloseIcon(false);
                    props.setbackgroundModal(true);
                    props.setModalObject({
                      content: () => (
                        <UploadCustomPolicy
                          currentItem={props.currentItem}
                          closeModal={props.closeModal}
                          saveDocument={props.editCustomPolicy}
                          uploadApi={props.uploadApi}
                          callback={props.callback}
                          parent="policies"
                          currentData={{
                            id: row?.id,
                            policyDocId: row?.policyDocId,
                            name: row.nameValue,
                            language: row.languageValue,
                          }}
                          languages={props.languages}
                        />
                      ),
                    });
                    props.clickedModal();
                  }}
                />
                <div>&nbsp;</div>
                <Icon
                  src={mediaUrls?.deleteIcon}
                  onClick={() => {
                    props.setwithCloseIcon(false);
                    props.setbackgroundModal(true);
                    props.setModalObject({
                      content: () => (
                        <div className="deleteParent">
                          <div className="imageSection">
                            <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
                          </div>
                          <h2> {i18n.t('common.sureConfirm')} </h2>
                          <div className="deletePopupBtn">
                            <div className="cancelBtn">
                              <Button
                                label={i18n.t('Cancel')}
                                type={'reset'}
                                onClick={() => {
                                  props.closeModal();
                                }}
                              ></Button>
                            </div>
                            <div className="deletebtn">
                              <Button
                                label={i18n.t('common.deletePopup')}
                                onClick={() => {
                                  props.handleDeleteCustomPolicyAlert({
                                    id: 'deleteAlert',
                                    data: {
                                      id: row?.id,
                                    },
                                    callback: props.callback,
                                  });
                                  props.closeModal();
                                }}
                              ></Button>
                            </div>
                          </div>
                        </div>
                      ),
                    });
                    props.clickedModal();
                  }}
                />
              </React.Fragment>
            );
          },
        },
      ]}
      i18n={i18n}
    />
  );
}
